/* eslint-disable multiline-ternary */
import { Spinner, Flex, Box } from '@chakra-ui/react'
import { useIntl } from 'react-intl'
import PageHeader from '../../components/InternalAppShell/PageHeader'
import { CalendarDaysIcon } from '@heroicons/react/24/outline'
import InternalAppShell from '../../components/InternalAppShell'
import CalendarCore from '../../client/modules/Calendar/components/CalendarCore'
import { useAccount } from '../../client/modules/account/AccountProvider'
import { useRole } from '../../providers/RoleProvider'
import { normalizeAppointmentSettings } from '../../utils/appointmentUtils'
import { useSearchParams } from 'react-router-dom'
import { useMemo } from 'react'

export default function Calendar() {
  const { formatMessage } = useIntl()
  const account = useAccount()
  const { role, loading } = useRole()
  const [searchParams] = useSearchParams()
  const requestedDate = searchParams.get('date')
  const appointmentSettings = useMemo(
    () => normalizeAppointmentSettings(account.appointmentSettings),
    [account.appointmentSettings]
  )
  const initialDate =
    requestedDate && /^\d{4}-\d{2}-\d{2}$/.test(requestedDate)
      ? requestedDate
      : undefined

  return (
    <InternalAppShell
      role={role === 'secretary' ? 'secretary' : 'doctor'}
      title={formatMessage({ id: 'internalNav.calendar' })}
      contentMode="wide"
    >
      <Flex direction="column" gap={6} maxW="1240px" mx="auto">
        <PageHeader
          title={formatMessage({ id: 'internalNav.calendar' })}
          description={formatMessage({ id: 'page.calendarDescription' })}
          icon={CalendarDaysIcon}
        />
        <Box h={{ base: '760px', md: 'calc(100dvh - 220px)' }} minH="560px">
          {loading || account.loading ? (
            <Flex justify="center" py={16}>
              <Spinner />
            </Flex>
          ) : (
            <CalendarCore
              settings={appointmentSettings}
              initialDate={initialDate}
            />
          )}
        </Box>
      </Flex>
    </InternalAppShell>
  )
}
